import api from '../../../api';

export const blacklistDomain = async (domains: string) =>
  api.post('/blacklist-domains', { domains });

export const getBlacklistDomains = async () => api.get('/blacklist-domains');

export const deleteBlacklistedDomain = async (domainId: number) =>
  api.delete(`/blacklist-domains/${domainId}`);
